import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnDestroy, Output, ViewChild } from '@angular/core';

import { ApiError, MessageService } from '../../../../../../core';
import { ClienteCentralCompraParticipante } from '../cliente-central-compra-participante';
import { ClienteCentralCompraParticipanteHttpService } from '../services';

@Component({
    selector: 'sgt-cliente-central-compra-participante-pipeline-card',
    templateUrl: './cliente-central-compra-participante-pipeline-card.component.html',
    styleUrls: ['./cliente-central-compra-participante-pipeline-card.component.less']
})
export class ClienteCentralCompraParticipantePipelineCardComponent implements AfterViewInit, OnDestroy {
    /** Título do card */
    @Input() title = 'Participantes';

    // Messages
    /** Mensagem de carregando dos participantes */
    @Input() isLoadingMessage = 'Carregando os participantes';
    /** Mensagem de erro ao pesquisar os participantes */
    @Input() searchErrorMessage = 'Erro ao carregar os participantes';
    /** Mensagem quando não for encontrada nenhum participante */
    @Input() emptyMessage = 'Nenhum participante encontrado';

    @Output() open = new EventEmitter<ClienteCentralCompraParticipante>();

    // Collapse
    @ViewChild('collapse') collapse: ElementRef;
    isCollapseOpened = false;

    isLoading: boolean;
    isLoaded: boolean;
    participantes: ClienteCentralCompraParticipante[];

    constructor(private messageService: MessageService,
                private clienteCentralCompraParticipanteHttpService: ClienteCentralCompraParticipanteHttpService) {}


    ngAfterViewInit() {
        // Registrando evento ao abrir o collapse
        jQuery(this.collapse?.nativeElement).on('show.bs.collapse', () => {
            this.isCollapseOpened = true;
        });
        // Registrando evento ao fechar o collapse
        jQuery(this.collapse?.nativeElement).on('hidden.bs.collapse', () => {
            this.isCollapseOpened = false;
        });
    }

    /** Abre/Fecha o collapse */
    toggleCollapse() {
        if (!this.isCollapseOpened) {
            this.openCollapse();
        } else {
            this.closeCollpase();
        }
    }

    /** Abre o collapse */
    private openCollapse() {
        (jQuery(this.collapse?.nativeElement) as any).collapse('show');
    }

    /** Fecha o collapse */
    private closeCollpase() {
        (jQuery(this.collapse?.nativeElement) as any).collapse('hide');
    }

    /** Pesquisa os participantes da central de compras */
    search(idClienteCentralCompra: number): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.isLoading = true;
            this.isLoaded = false;

            this.searchParticipantes(idClienteCentralCompra)
                .then(() => {
                    this.isLoading = false;
                    this.isLoaded = true;
                    resolve();
                }).catch(error => {
                    this.isLoading = false;
                    this.isLoaded = false;
                    reject(error);
                });
        });
    }

    /** Pesquisa os participantes */
    private searchParticipantes(idClienteCentralCompra: number): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.clienteCentralCompraParticipanteHttpService.search(idClienteCentralCompra)
                .subscribe(
                    entities => {
                        this.participantes = entities;
                        resolve();
                    },
                    (error: ApiError) => {
                        this.messageService.error(error.message, this.searchErrorMessage, error);
                        reject();
                    }
                );
        });
    }

    /** Emite evento para abrir um participante */
    openClick(participante: ClienteCentralCompraParticipante) {
        this.open.emit(participante);
    }

    ngOnDestroy() {
        // Removendo evento ao abrir o collapse
        jQuery(this.collapse?.nativeElement).off('show.bs.collapse');
        // Removendo evento ao fechar o collapse
        jQuery(this.collapse?.nativeElement).off('hidden.bs.collapse');
    }
}
